var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 373,
    viewBox: "0 0 500 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1937_6763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 327.45H0V327.7H500V327.45Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.901 343.54H416.781V343.79H449.901V343.54Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.221 346.26H322.531V346.51H331.221V346.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.78 334.26H396.59V334.51H415.78V334.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6509 335.94H52.4609V336.19H95.6509V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.889 335.94H104.559V336.19H110.889V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.149 340.16H131.469V340.41H225.149V340.16Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.009 282.85H43.9092C40.7592 282.85 38.1992 280.29 38.1992 277.14V5.71C38.1992 2.56 40.7592 0 43.9092 0H237.009C240.159 0 242.719 2.56 242.719 5.71V277.14C242.719 280.29 240.159 282.85 237.009 282.85ZM43.9092 0.25C40.8992 0.25 38.4492 2.7 38.4492 5.71V277.14C38.4492 280.15 40.8992 282.6 43.9092 282.6H237.009C240.019 282.6 242.469 280.15 242.469 277.14V5.71C242.469 2.7 240.019 0.25 237.009 0.25H43.9092Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 282.85H260.21C257.06 282.85 254.5 280.29 254.5 277.14V5.71C254.5 2.56 257.06 0 260.21 0H453.31C456.46 0 459.02 2.56 459.02 5.71V277.14C459.02 280.29 456.46 282.85 453.31 282.85ZM260.21 0.25C257.2 0.25 254.75 2.7 254.75 5.71V277.14C254.75 280.15 257.2 282.6 260.21 282.6H453.31C456.32 282.6 458.77 280.15 458.77 277.14V5.71C458.77 2.7 456.32 0.25 453.31 0.25H260.21Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.417 62.22H203.137V295.76H445.417V62.22Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.417 66.46H207.027V291.68H445.417V66.46Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.787 237.14V169.4H215.817V160.45L231.657 153.04V143.89H234.297V169.4H236.937V237.14H240.457V201.95H248.377V183.48H251.017V237.14H257.167V216.91H261.567V211.63H271.247V193.15H276.527V180.84H282.687V162.36H285.327V180.84H291.487V193.15H296.757V211.63H306.437V216.91H310.837V237.14H316.117V211.63H325.797V155.32H328.437V149.16H349.547V155.32H353.947V195.79H371.547V200.19H377.697V202.83H371.547V218.67H390.017V165.88H393.537V155.32H402.337V114.85H404.977V155.32H411.137V165.88H445.417V291.69H207.027V237.14H208.787Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 168.64H424.605V171.13H427.095V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 172.82H424.605V175.31H427.095V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 189.53H424.605V192.02H427.095V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 193.71H424.605V196.2H427.095V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 197.89H424.605V200.38H427.095V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 210.43H424.605V212.92H427.095V210.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.095 214.61H424.605V217.1H427.095V214.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 185.35H420.648V187.84H423.138V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 189.53H420.648V192.02H423.138V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 193.71H420.648V196.2H423.138V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 197.89H420.648V200.38H423.138V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 202.07H420.648V204.56H423.138V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 210.43H420.648V212.92H423.138V210.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.138 214.61H420.648V217.1H423.138V214.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 168.64H416.688V171.13H419.177V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 172.82H416.688V175.31H419.177V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 177H416.688V179.49H419.177V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 181.18H416.688V183.67H419.177V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 185.35H416.688V187.84H419.177V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 189.53H416.688V192.02H419.177V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 193.71H416.688V196.2H419.177V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 197.89H416.688V200.38H419.177V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 202.07H416.688V204.56H419.177V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 206.25H416.688V208.74H419.177V206.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.177 214.61H416.688V217.1H419.177V214.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 168.64H412.727V171.13H415.217V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 172.82H412.727V175.31H415.217V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 177H412.727V179.49H415.217V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 181.18H412.727V183.67H415.217V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 185.35H412.727V187.84H415.217V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 189.53H412.727V192.02H415.217V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 193.71H412.727V196.2H415.217V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.217 231.32H412.727V233.81H415.217V231.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 168.64H408.766V171.13H411.256V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 172.82H408.766V175.31H411.256V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 177H408.766V179.49H411.256V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 181.18H408.766V183.67H411.256V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 185.35H408.766V187.84H411.256V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 189.53H408.766V192.02H411.256V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 193.71H408.766V196.2H411.256V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 197.89H408.766V200.38H411.256V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 222.97H408.766V225.46H411.256V222.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 227.14H408.766V229.63H411.256V227.14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 231.32H408.766V233.81H411.256V231.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 235.5H408.766V237.99H411.256V235.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.256 252.22H408.766V254.71H411.256V252.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 168.64H404.809V171.13H407.299V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 172.82H404.809V175.31H407.299V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 177H404.809V179.49H407.299V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 181.18H404.809V183.67H407.299V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 185.35H404.809V187.84H407.299V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 189.53H404.809V192.02H407.299V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 193.71H404.809V196.2H407.299V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 197.89H404.809V200.38H407.299V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 202.07H404.809V204.56H407.299V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 206.25H404.809V208.74H407.299V206.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 218.79H404.809V221.28H407.299V218.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 222.97H404.809V225.46H407.299V222.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 227.14H404.809V229.63H407.299V227.14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 231.32H404.809V233.81H407.299V231.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 235.5H404.809V237.99H407.299V235.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.299 252.22H404.809V254.71H407.299V252.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 168.64H400.848V171.13H403.338V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 172.82H400.848V175.31H403.338V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 177H400.848V179.49H403.338V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 181.18H400.848V183.67H403.338V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 185.35H400.848V187.84H403.338V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 189.53H400.848V192.02H403.338V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 193.71H400.848V196.2H403.338V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 197.89H400.848V200.38H403.338V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 202.07H400.848V204.56H403.338V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 206.25H400.848V208.74H403.338V206.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 210.43H400.848V212.92H403.338V210.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 214.61H400.848V217.1H403.338V214.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 218.79H400.848V221.28H403.338V218.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 222.97H400.848V225.46H403.338V222.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 227.14H400.848V229.63H403.338V227.14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 231.32H400.848V233.81H403.338V231.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 235.5H400.848V237.99H403.338V235.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.338 239.68H400.848V242.17H403.338V239.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 168.64H396.887V171.13H399.377V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 172.82H396.887V175.31H399.377V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 177H396.887V179.49H399.377V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 181.18H396.887V183.67H399.377V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 185.35H396.887V187.84H399.377V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 189.53H396.887V192.02H399.377V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 193.71H396.887V196.2H399.377V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 197.89H396.887V200.38H399.377V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 202.07H396.887V204.56H399.377V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 206.25H396.887V208.74H399.377V206.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 218.79H396.887V221.28H399.377V218.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 222.97H396.887V225.46H399.377V222.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 227.14H396.887V229.63H399.377V227.14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.377 231.32H396.887V233.81H399.377V231.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 168.64H392.938V171.13H395.427V168.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 172.82H392.938V175.31H395.427V172.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 177H392.938V179.49H395.427V177Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 181.18H392.938V183.67H395.427V181.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 185.35H392.938V187.84H395.427V185.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 189.53H392.938V192.02H395.427V189.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 193.71H392.938V196.2H395.427V193.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 197.89H392.938V200.38H395.427V197.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 202.07H392.938V204.56H395.427V202.07Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 206.25H392.938V208.74H395.427V206.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 218.79H392.938V221.28H395.427V218.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 222.97H392.938V225.46H395.427V222.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.427 227.14H392.938V229.63H395.427V227.14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 157.79H348.355V160.28H350.845V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 161.97H348.355V164.46H350.845V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 166.15H348.355V168.64H350.845V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 170.32H348.355V172.81H350.845V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 174.5H348.355V176.99H350.845V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 178.68H348.355V181.17H350.845V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 182.86H348.355V185.35H350.845V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 187.04H348.355V189.53H350.845V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 199.58H348.355V202.07H350.845V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.845 203.76H348.355V206.25H350.845V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 157.79H344.398V160.28H346.888V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 161.97H344.398V164.46H346.888V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 166.15H344.398V168.64H346.888V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 170.32H344.398V172.81H346.888V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 174.5H344.398V176.99H346.888V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 178.68H344.398V181.17H346.888V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 182.86H344.398V185.35H346.888V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 187.04H344.398V189.53H346.888V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.888 203.76H344.398V206.25H346.888V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 157.79H340.438V160.28H342.927V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 161.97H340.438V164.46H342.927V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 166.15H340.438V168.64H342.927V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 170.32H340.438V172.81H342.927V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 174.5H340.438V176.99H342.927V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 178.68H340.438V181.17H342.927V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 182.86H340.438V185.35H342.927V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.927 187.04H340.438V189.53H342.927V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 157.79H336.477V160.28H338.967V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 161.97H336.477V164.46H338.967V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 166.15H336.477V168.64H338.967V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 170.32H336.477V172.81H338.967V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 174.5H336.477V176.99H338.967V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 178.68H336.477V181.17H338.967V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 187.04H336.477V189.53H338.967V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 191.22H336.477V193.71H338.967V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 203.76H336.477V206.25H338.967V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 207.94H336.477V210.43H338.967V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 212.11H336.477V214.6H338.967V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 216.29H336.477V218.78H338.967V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 220.47H336.477V222.96H338.967V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 224.65H336.477V227.14H338.967V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.967 228.83H336.477V231.32H338.967V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 157.79H332.516V160.28H335.006V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 161.97H332.516V164.46H335.006V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 166.15H332.516V168.64H335.006V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 170.32H332.516V172.81H335.006V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 174.5H332.516V176.99H335.006V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 178.68H332.516V181.17H335.006V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 191.22H332.516V193.71H335.006V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 195.4H332.516V197.89H335.006V195.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 199.58H332.516V202.07H335.006V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 203.76H332.516V206.25H335.006V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 207.94H332.516V210.43H335.006V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 212.11H332.516V214.6H335.006V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 216.29H332.516V218.78H335.006V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 220.47H332.516V222.96H335.006V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 224.65H332.516V227.14H335.006V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 228.83H332.516V231.32H335.006V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 233.01H332.516V235.5H335.006V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.006 241.37H332.516V243.86H335.006V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 157.79H328.559V160.28H331.049V157.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 161.97H328.559V164.46H331.049V161.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 166.15H328.559V168.64H331.049V166.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 170.32H328.559V172.81H331.049V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 174.5H328.559V176.99H331.049V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 178.68H328.559V181.17H331.049V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 191.22H328.559V193.71H331.049V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 195.4H328.559V197.89H331.049V195.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 199.58H328.559V202.07H331.049V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 203.76H328.559V206.25H331.049V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 216.29H328.559V218.78H331.049V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 220.47H328.559V222.96H331.049V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 224.65H328.559V227.14H331.049V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 228.83H328.559V231.32H331.049V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 233.01H328.559V235.5H331.049V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 241.37H328.559V243.86H331.049V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.049 245.55H328.559V248.04H331.049V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 196.64H292.637V199.13H295.127V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 200.82H292.637V203.31H295.127V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 205H292.637V207.49H295.127V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 209.18H292.637V211.67H295.127V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 213.36H292.637V215.85H295.127V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 217.54H292.637V220.03H295.127V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 221.72H292.637V224.21H295.127V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 234.26H292.637V236.75H295.127V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 238.43H292.637V240.92H295.127V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.127 242.61H292.637V245.1H295.127V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 196.64H288.676V199.13H291.166V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 200.82H288.676V203.31H291.166V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 205H288.676V207.49H291.166V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 209.18H288.676V211.67H291.166V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 213.36H288.676V215.85H291.166V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 217.54H288.676V220.03H291.166V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.166 221.72H288.676V224.21H291.166V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 196.64H284.719V199.13H287.209V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 200.82H284.719V203.31H287.209V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 205H284.719V207.49H287.209V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 209.18H284.719V211.67H287.209V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 213.36H284.719V215.85H287.209V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 217.54H284.719V220.03H287.209V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.209 221.72H284.719V224.21H287.209V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 196.64H280.758V199.13H283.248V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 200.82H280.758V203.31H283.248V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 205H280.758V207.49H283.248V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 209.18H280.758V211.67H283.248V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 213.36H280.758V215.85H283.248V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 217.54H280.758V220.03H283.248V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 221.72H280.758V224.21H283.248V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 225.9H280.758V228.39H283.248V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 230.08H280.758V232.57H283.248V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 234.26H280.758V236.75H283.248V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.248 238.43H280.758V240.92H283.248V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 196.64H276.797V199.13H279.287V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 200.82H276.797V203.31H279.287V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 205H276.797V207.49H279.287V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 209.18H276.797V211.67H279.287V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 213.36H276.797V215.85H279.287V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 217.54H276.797V220.03H279.287V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 221.72H276.797V224.21H279.287V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 225.9H276.797V228.39H279.287V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 230.08H276.797V232.57H279.287V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 234.26H276.797V236.75H279.287V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 238.43H276.797V240.92H279.287V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 242.61H276.797V245.1H279.287V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 255.15H276.797V257.64H279.287V255.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.287 259.33H276.797V261.82H279.287V259.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 196.64H272.836V199.13H275.326V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 200.82H272.836V203.31H275.326V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 205H272.836V207.49H275.326V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 217.54H272.836V220.03H275.326V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 221.72H272.836V224.21H275.326V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 225.9H272.836V228.39H275.326V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 230.08H272.836V232.57H275.326V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 234.26H272.836V236.75H275.326V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 238.43H272.836V240.92H275.326V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 242.61H272.836V245.1H275.326V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 255.15H272.836V257.64H275.326V255.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 259.33H272.836V261.82H275.326V259.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.326 263.51H272.836V266H275.326V263.51Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 171.57H231.348V174.06H233.838V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 175.75H231.348V178.24H233.838V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 179.93H231.348V182.42H233.838V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 184.11H231.348V186.6H233.838V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 188.29H231.348V190.78H233.838V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 192.47H231.348V194.96H233.838V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 196.64H231.348V199.13H233.838V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 200.82H231.348V203.31H233.838V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 205H231.348V207.49H233.838V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 209.18H231.348V211.67H233.838V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 213.36H231.348V215.85H233.838V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 217.54H231.348V220.03H233.838V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 221.72H231.348V224.21H233.838V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 225.9H231.348V228.39H233.838V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 230.08H231.348V232.57H233.838V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 234.26H231.348V236.75H233.838V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 238.43H231.348V240.92H233.838V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 242.61H231.348V245.1H233.838V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 246.79H231.348V249.28H233.838V246.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 250.97H231.348V253.46H233.838V250.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 255.15H231.348V257.64H233.838V255.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 259.33H231.348V261.82H233.838V259.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.838 263.51H231.348V266H233.838V263.51Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 171.57H227.387V174.06H229.877V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 175.75H227.387V178.24H229.877V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 179.93H227.387V182.42H229.877V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 184.11H227.387V186.6H229.877V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 188.29H227.387V190.78H229.877V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 192.47H227.387V194.96H229.877V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 196.64H227.387V199.13H229.877V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 200.82H227.387V203.31H229.877V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 205H227.387V207.49H229.877V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 209.18H227.387V211.67H229.877V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 213.36H227.387V215.85H229.877V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 217.54H227.387V220.03H229.877V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 221.72H227.387V224.21H229.877V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 225.9H227.387V228.39H229.877V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 230.08H227.387V232.57H229.877V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 234.26H227.387V236.75H229.877V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 238.43H227.387V240.92H229.877V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 242.61H227.387V245.1H229.877V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.877 246.79H227.387V249.28H229.877V246.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 171.57H223.426V174.06H225.916V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 175.75H223.426V178.24H225.916V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 179.93H223.426V182.42H225.916V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 184.11H223.426V186.6H225.916V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 188.29H223.426V190.78H225.916V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 192.47H223.426V194.96H225.916V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 196.64H223.426V199.13H225.916V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 200.82H223.426V203.31H225.916V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 205H223.426V207.49H225.916V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 209.18H223.426V211.67H225.916V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 213.36H223.426V215.85H225.916V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 217.54H223.426V220.03H225.916V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 221.72H223.426V224.21H225.916V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 225.9H223.426V228.39H225.916V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 230.08H223.426V232.57H225.916V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 234.26H223.426V236.75H225.916V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 238.43H223.426V240.92H225.916V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 242.61H223.426V245.1H225.916V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.916 246.79H223.426V249.28H225.916V246.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 171.57H219.469V174.06H221.959V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 175.75H219.469V178.24H221.959V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 179.93H219.469V182.42H221.959V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 184.11H219.469V186.6H221.959V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 188.29H219.469V190.78H221.959V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 192.47H219.469V194.96H221.959V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 196.64H219.469V199.13H221.959V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 200.82H219.469V203.31H221.959V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 205H219.469V207.49H221.959V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 209.18H219.469V211.67H221.959V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 213.36H219.469V215.85H221.959V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 217.54H219.469V220.03H221.959V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 221.72H219.469V224.21H221.959V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 225.9H219.469V228.39H221.959V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.959 230.08H219.469V232.57H221.959V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 171.57H215.508V174.06H217.998V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 175.75H215.508V178.24H217.998V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 179.93H215.508V182.42H217.998V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 184.11H215.508V186.6H217.998V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 188.29H215.508V190.78H217.998V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 192.47H215.508V194.96H217.998V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 196.64H215.508V199.13H217.998V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 200.82H215.508V203.31H217.998V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 205H215.508V207.49H217.998V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 209.18H215.508V211.67H217.998V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 213.36H215.508V215.85H217.998V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 217.54H215.508V220.03H217.998V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.998 221.72H215.508V224.21H217.998V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 171.57H211.547V174.06H214.037V171.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 175.75H211.547V178.24H214.037V175.75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 179.93H211.547V182.42H214.037V179.93Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 184.11H211.547V186.6H214.037V184.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 188.29H211.547V190.78H214.037V188.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 192.47H211.547V194.96H214.037V192.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 196.64H211.547V199.13H214.037V196.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 200.82H211.547V203.31H214.037V200.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 205H211.547V207.49H214.037V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 209.18H211.547V211.67H214.037V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 213.36H211.547V215.85H214.037V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.037 217.54H211.547V220.03H214.037V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 170.32H442.637V172.81H445.127V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 174.5H442.637V176.99H445.127V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 178.68H442.637V181.17H445.127V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 182.86H442.637V185.35H445.127V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 187.04H442.637V189.53H445.127V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 191.22H442.637V193.71H445.127V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 195.4H442.637V197.89H445.127V195.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 199.58H442.637V202.07H445.127V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 203.76H442.637V206.25H445.127V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 207.94H442.637V210.43H445.127V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 212.11H442.637V214.6H445.127V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 216.29H442.637V218.78H445.127V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 220.47H442.637V222.96H445.127V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 224.65H442.637V227.14H445.127V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 228.83H442.637V231.32H445.127V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 233.01H442.637V235.5H445.127V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 237.19H442.637V239.68H445.127V237.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 245.55H442.637V248.04H445.127V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 249.73H442.637V252.22H445.127V249.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 253.9H442.637V256.39H445.127V253.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 258.08H442.637V260.57H445.127V258.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.127 262.26H442.637V264.75H445.127V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 170.32H438.676V172.81H441.166V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 174.5H438.676V176.99H441.166V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 178.68H438.676V181.17H441.166V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 182.86H438.676V185.35H441.166V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 187.04H438.676V189.53H441.166V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 191.22H438.676V193.71H441.166V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 195.4H438.676V197.89H441.166V195.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 199.58H438.676V202.07H441.166V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 203.76H438.676V206.25H441.166V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 207.94H438.676V210.43H441.166V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 212.11H438.676V214.6H441.166V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 216.29H438.676V218.78H441.166V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 220.47H438.676V222.96H441.166V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 224.65H438.676V227.14H441.166V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 228.83H438.676V231.32H441.166V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 233.01H438.676V235.5H441.166V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 258.08H438.676V260.57H441.166V258.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.166 262.26H438.676V264.75H441.166V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 170.32H434.727V172.81H437.217V170.32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 174.5H434.727V176.99H437.217V174.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 178.68H434.727V181.17H437.217V178.68Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 182.86H434.727V185.35H437.217V182.86Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 187.04H434.727V189.53H437.217V187.04Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 191.22H434.727V193.71H437.217V191.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 195.4H434.727V197.89H437.217V195.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 199.58H434.727V202.07H437.217V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 203.76H434.727V206.25H437.217V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 207.94H434.727V210.43H437.217V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 212.11H434.727V214.6H437.217V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 216.29H434.727V218.78H437.217V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 220.47H434.727V222.96H437.217V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 224.65H434.727V227.14H437.217V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 228.83H434.727V231.32H437.217V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 233.01H434.727V235.5H437.217V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 241.37H434.727V243.86H437.217V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 245.55H434.727V248.04H437.217V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 249.73H434.727V252.22H437.217V249.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 253.9H434.727V256.39H437.217V253.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.217 262.26H434.727V264.75H437.217V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 199.58H365.656V202.07H368.146V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 203.76H365.656V206.25H368.146V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 207.94H365.656V210.43H368.146V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 212.11H365.656V214.6H368.146V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 216.29H365.656V218.78H368.146V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 220.47H365.656V222.96H368.146V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 224.65H365.656V227.14H368.146V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 228.83H365.656V231.32H368.146V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 233.01H365.656V235.5H368.146V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 237.19H365.656V239.68H368.146V237.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 241.37H365.656V243.86H368.146V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 245.55H365.656V248.04H368.146V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 249.73H365.656V252.22H368.146V249.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 258.08H365.656V260.57H368.146V258.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 262.26H365.656V264.75H368.146V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 266.44H365.656V268.93H368.146V266.44Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 270.62H365.656V273.11H368.146V270.62Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 278.98H365.656V281.47H368.146V278.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 283.16H365.656V285.65H368.146V283.16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.146 287.34H365.656V289.83H368.146V287.34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 199.58H361.695V202.07H364.185V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 203.76H361.695V206.25H364.185V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 207.94H361.695V210.43H364.185V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 212.11H361.695V214.6H364.185V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 216.29H361.695V218.78H364.185V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 220.47H361.695V222.96H364.185V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 224.65H361.695V227.14H364.185V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 228.83H361.695V231.32H364.185V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 233.01H361.695V235.5H364.185V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 237.19H361.695V239.68H364.185V237.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 241.37H361.695V243.86H364.185V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 245.55H361.695V248.04H364.185V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 249.73H361.695V252.22H364.185V249.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 262.26H361.695V264.75H364.185V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 266.44H361.695V268.93H364.185V266.44Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 274.8H361.695V277.29H364.185V274.8Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 278.98H361.695V281.47H364.185V278.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 283.16H361.695V285.65H364.185V283.16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.185 287.34H361.695V289.83H364.185V287.34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 199.58H357.738V202.07H360.228V199.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 203.76H357.738V206.25H360.228V203.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 207.94H357.738V210.43H360.228V207.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 212.11H357.738V214.6H360.228V212.11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 216.29H357.738V218.78H360.228V216.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 220.47H357.738V222.96H360.228V220.47Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 224.65H357.738V227.14H360.228V224.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 228.83H357.738V231.32H360.228V228.83Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 233.01H357.738V235.5H360.228V233.01Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 237.19H357.738V239.68H360.228V237.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 241.37H357.738V243.86H360.228V241.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 245.55H357.738V248.04H360.228V245.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 249.73H357.738V252.22H360.228V249.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 253.9H357.738V256.39H360.228V253.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 262.26H357.738V264.75H360.228V262.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 270.62H357.738V273.11H360.228V270.62Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 274.8H357.738V277.29H360.228V274.8Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 278.98H357.738V281.47H360.228V278.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 283.16H357.738V285.65H360.228V283.16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.228 287.34H357.738V289.83H360.228V287.34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 223.41H381.785V225.9H384.275V223.41Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 227.58H381.785V230.07H384.275V227.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 231.76H381.785V234.25H384.275V231.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 235.94H381.785V238.43H384.275V235.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 240.12H381.785V242.61H384.275V240.12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 244.3H381.785V246.79H384.275V244.3Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 256.84H381.785V259.33H384.275V256.84Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 261.02H381.785V263.51H384.275V261.02Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 265.19H381.785V267.68H384.275V265.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 269.37H381.785V271.86H384.275V269.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 273.55H381.785V276.04H384.275V273.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 277.73H381.785V280.22H384.275V277.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.275 281.91H381.785V284.4H384.275V281.91Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 223.41H377.828V225.9H380.318V223.41Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 227.58H377.828V230.07H380.318V227.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 231.76H377.828V234.25H380.318V231.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 235.94H377.828V238.43H380.318V235.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 240.12H377.828V242.61H380.318V240.12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 244.3H377.828V246.79H380.318V244.3Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 256.84H377.828V259.33H380.318V256.84Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 261.02H377.828V263.51H380.318V261.02Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 265.19H377.828V267.68H380.318V265.19Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 269.37H377.828V271.86H380.318V269.37Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 273.55H377.828V276.04H380.318V273.55Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 277.73H377.828V280.22H380.318V277.73Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.318 286.09H377.828V288.58H380.318V286.09Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 205H246.297V207.49H248.787V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 209.18H246.297V211.67H248.787V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 213.36H246.297V215.85H248.787V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 217.54H246.297V220.03H248.787V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 221.72H246.297V224.21H248.787V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 225.9H246.297V228.39H248.787V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 230.08H246.297V232.57H248.787V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 234.26H246.297V236.75H248.787V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 238.43H246.297V240.92H248.787V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 242.61H246.297V245.1H248.787V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 246.79H246.297V249.28H248.787V246.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 255.15H246.297V257.64H248.787V255.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 259.33H246.297V261.82H248.787V259.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 263.51H246.297V266H248.787V263.51Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 267.69H246.297V270.18H248.787V267.69Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 271.87H246.297V274.36H248.787V271.87Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 276.05H246.297V278.54H248.787V276.05Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 280.22H246.297V282.71H248.787V280.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.787 284.4H246.297V286.89H248.787V284.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 205H242.348V207.49H244.838V205Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 209.18H242.348V211.67H244.838V209.18Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 213.36H242.348V215.85H244.838V213.36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 217.54H242.348V220.03H244.838V217.54Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 221.72H242.348V224.21H244.838V221.72Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 225.9H242.348V228.39H244.838V225.9Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 230.08H242.348V232.57H244.838V230.08Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 234.26H242.348V236.75H244.838V234.26Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 238.43H242.348V240.92H244.838V238.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 242.61H242.348V245.1H244.838V242.61Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 246.79H242.348V249.28H244.838V246.79Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 250.97H242.348V253.46H244.838V250.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 255.15H242.348V257.64H244.838V255.15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 259.33H242.348V261.82H244.838V259.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 263.51H242.348V266H244.838V263.51Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 267.69H242.348V270.18H244.838V267.69Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 271.87H242.348V274.36H244.838V271.87Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 276.05H242.348V278.54H244.838V276.05Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 280.22H242.348V282.71H244.838V280.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.838 284.4H242.348V286.89H244.838V284.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 221.28H265.809V223.77H268.299V221.28Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 225.46H265.809V227.95H268.299V225.46Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 229.64H265.809V232.13H268.299V229.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 233.82H265.809V236.31H268.299V233.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 237.99H265.809V240.48H268.299V237.99Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 242.17H265.809V244.66H268.299V242.17Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 246.35H265.809V248.84H268.299V246.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 250.53H265.809V253.02H268.299V250.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 254.71H265.809V257.2H268.299V254.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.299 258.89H265.809V261.38H268.299V258.89Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 221.28H261.848V223.77H264.338V221.28Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 225.46H261.848V227.95H264.338V225.46Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 229.64H261.848V232.13H264.338V229.64Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 233.82H261.848V236.31H264.338V233.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 237.99H261.848V240.48H264.338V237.99Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 242.17H261.848V244.66H264.338V242.17Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 246.35H261.848V248.84H264.338V246.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 250.53H261.848V253.02H264.338V250.53Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.338 254.71H261.848V257.2H264.338V254.71Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.887 62.6899H283.707V295.77H287.887V62.6899Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.598 62.6899H362.418V295.77H366.598V62.6899Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.297 62.6899H441.117V295.77H445.297V62.6899Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.818 273.09H173.598C176.028 273.09 178.008 275.06 178.008 277.5V327.33H143.418V277.5C143.418 275.07 145.388 273.09 147.828 273.09H147.818Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.008 280.42H143.418V284.31H178.008V280.42Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.089 320.76H171.709C173.019 320.76 174.079 321.82 174.079 323.13V327.33H160.719V323.13C160.719 321.82 161.779 320.76 163.089 320.76Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.118 327.33H164.528C163.678 327.33 162.988 326.64 162.988 325.79C162.988 324.94 163.678 324.25 164.528 324.25H174.118C174.968 324.25 175.658 324.94 175.658 325.79C175.658 326.64 174.968 327.33 174.118 327.33Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.708 51.7443C340.367 48.7566 348.207 36.0729 345.219 23.4144C342.231 10.7559 329.547 2.91613 316.889 5.90381C304.23 8.89149 296.391 21.5752 299.378 34.2337C302.366 46.8922 315.05 54.732 327.708 51.7443Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51 48.5682C336.43 46.7958 343.845 36.507 342.072 25.5877C340.3 14.6683 330.011 7.25333 319.092 9.02579C308.172 10.7982 300.757 21.087 302.53 32.0063C304.302 42.9257 314.591 50.3407 325.51 48.5682Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.238 15.08V29.08L332.518 23.83",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.238 15.08V29.08L332.518 23.83",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.927 258.69C95.127 255.73 92.167 258.3 92.167 258.3C92.587 252.62 87.367 248.74 87.367 248.74C87.367 248.74 93.437 248.74 94.287 242.95C95.137 237.16 92.167 239.85 89.387 239.81C86.607 239.77 83.697 247.89 87.367 252.46C91.037 257.03 90.047 264.83 81.587 272.33C79.517 274.16 78.117 276.6 77.167 279.23C77.807 272.34 78.167 262.63 76.137 256.15C72.697 245.14 79.257 242.18 81.157 236.67C83.067 231.17 76.137 226.51 76.137 226.51C76.137 226.51 82.647 223.55 79.467 220.16C76.287 216.77 69.727 217.23 69.727 221.66C69.727 226.09 74.177 227.78 74.177 227.78C74.177 227.78 79.257 233.07 79.257 235.83C79.257 238.59 74.177 244.51 74.177 244.51C74.177 244.51 76.507 239.44 71.847 239.22C67.187 239 65.707 245.14 67.617 247.9C69.527 250.65 72.697 248.32 72.697 248.32C72.697 248.32 73.067 254.25 74.157 257.85C74.637 259.43 74.407 265.64 74.007 272.1C73.067 269.77 71.737 267.63 69.887 265.98C61.417 258.48 60.437 250.68 64.107 246.11C67.777 241.54 64.867 233.42 62.087 233.46C59.307 233.5 56.337 230.8 57.187 236.6C58.037 242.4 64.107 242.39 64.107 242.39C64.107 242.39 58.877 246.28 59.307 251.95C59.307 251.95 56.347 249.37 54.547 252.34C51.337 257.63 58.777 260.91 60.037 258.31C60.037 258.31 75.827 269.49 72.017 285.58L72.907 286.89C72.797 288.19 72.717 288.97 72.717 288.97L73.957 288.44L75.367 290.51C75.297 294.53 75.727 297.5 75.727 297.5L79.507 291.93C75.697 275.84 91.487 264.66 91.487 264.66C92.737 267.26 100.187 263.98 96.977 258.69H96.927Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.927 258.69C95.127 255.73 92.167 258.3 92.167 258.3C92.587 252.62 87.367 248.74 87.367 248.74C87.367 248.74 93.437 248.74 94.287 242.95C95.137 237.16 92.167 239.85 89.387 239.81C86.607 239.77 83.697 247.89 87.367 252.46C91.037 257.03 90.047 264.83 81.587 272.33C79.517 274.16 78.117 276.6 77.167 279.23C77.807 272.34 78.167 262.63 76.137 256.15C72.697 245.14 79.257 242.18 81.157 236.67C83.067 231.17 76.137 226.51 76.137 226.51C76.137 226.51 82.647 223.55 79.467 220.16C76.287 216.77 69.727 217.23 69.727 221.66C69.727 226.09 74.177 227.78 74.177 227.78C74.177 227.78 79.257 233.07 79.257 235.83C79.257 238.59 74.177 244.51 74.177 244.51C74.177 244.51 76.507 239.44 71.847 239.22C67.187 239 65.707 245.14 67.617 247.9C69.527 250.65 72.697 248.32 72.697 248.32C72.697 248.32 73.067 254.25 74.157 257.85C74.637 259.43 74.407 265.64 74.007 272.1C73.067 269.77 71.737 267.63 69.887 265.98C61.417 258.48 60.437 250.68 64.107 246.11C67.777 241.54 64.867 233.42 62.087 233.46C59.307 233.5 56.337 230.8 57.187 236.6C58.037 242.4 64.107 242.39 64.107 242.39C64.107 242.39 58.877 246.28 59.307 251.95C59.307 251.95 56.347 249.37 54.547 252.34C51.337 257.63 58.777 260.91 60.037 258.31C60.037 258.31 75.827 269.49 72.017 285.58L72.907 286.89C72.797 288.19 72.717 288.97 72.717 288.97L73.957 288.44L75.367 290.51C75.297 294.53 75.727 297.5 75.727 297.5L79.507 291.93C75.697 275.84 91.487 264.66 91.487 264.66C92.737 267.26 100.187 263.98 96.977 258.69H96.927Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8378 327.33H57.6678L53.7578 287.72H97.7378L93.8378 327.33Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6681 283.35H51.8281V292.09H99.6681V283.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.999 372.61C357.082 372.61 443.889 367.542 443.889 361.29C443.889 355.038 357.082 349.97 249.999 349.97C142.917 349.97 56.1094 355.038 56.1094 361.29C56.1094 367.542 142.917 372.61 249.999 372.61Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.45 329.76C410.6 328.74 414.1 304.59 407.09 296.25C405.54 294.4 403.58 293.44 401.27 293.38C387.12 293.05 385.18 304.42 385.16 304.53L386.83 304.79C386.89 304.38 388.57 294.76 401.23 295.07C403.06 295.11 404.56 295.86 405.8 297.34C412.33 305.1 408.82 329.27 408.78 329.51L410.45 329.76Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.301 328.66L412.991 328.61C412.991 328.39 412.431 306.36 423.281 301.81C433.921 297.35 438.701 306.52 438.901 306.91L440.411 306.15C440.351 306.04 434.741 295.17 422.631 300.25C410.711 305.25 411.271 327.71 411.301 328.66Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.253 330.39C411.253 330.04 411.353 295.2 418.143 285.01C424.663 275.23 435.183 279.83 435.633 280.03L436.332 278.49C436.212 278.43 424.072 273.08 416.742 284.07C409.672 294.68 409.562 328.93 409.562 330.39H411.253Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.242 294.23C399.242 294.23 405.422 296.51 403.582 301.89C401.742 307.27 382.202 316.12 382.202 316.12C382.202 316.12 374.022 308.62 381.532 296.42C389.052 284.22 399.072 290.39 399.232 294.23H399.242Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.453 283.18C418.453 283.18 414.063 282.71 414.423 280.04C414.783 277.37 431.473 270.49 441.333 281.61C441.333 281.61 435.023 292.45 425.903 292.59C416.783 292.73 418.463 283.18 418.463 283.18H418.453Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.963 301.03C422.963 301.03 419.933 298.59 423.203 297.39C426.473 296.2 442.503 296.54 442.673 312.42C442.673 312.42 424.003 315.52 421.693 309.47C419.383 303.42 422.973 301.03 422.973 301.03H422.963Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M399.242 294.23C399.242 294.23 405.422 296.51 403.582 301.89C401.742 307.27 382.202 316.12 382.202 316.12C382.202 316.12 374.022 308.62 381.532 296.42C389.052 284.22 399.072 290.39 399.232 294.23H399.242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M418.453 283.18C418.453 283.18 414.063 282.71 414.423 280.04C414.783 277.37 431.473 270.49 441.333 281.61C441.333 281.61 435.023 292.45 425.903 292.59C416.783 292.73 418.463 283.18 418.463 283.18H418.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M422.963 301.03C422.963 301.03 419.933 298.59 423.203 297.39C426.473 296.2 442.503 296.54 442.673 312.42C442.673 312.42 424.003 315.52 421.693 309.47C419.383 303.42 422.973 301.03 422.973 301.03H422.963Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.921 362.12H424.901L428.021 330.39H392.801L395.921 362.12Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.921 362.12H424.901L428.021 330.39H392.801L395.921 362.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25 333.9H429.57V326.9H391.25V333.9Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.25 333.9H429.57V326.9H391.25V333.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.122 339.38L334.312 336.55V296.06H322.892V336.54L293.962 339.38C291.092 339.66 288.902 342.08 288.902 344.96V349.29H368.182V344.96C368.182 342.07 365.992 339.66 363.122 339.38Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.122 339.38L334.312 336.55V296.06H322.892V336.54L293.962 339.38C291.092 339.66 288.902 342.08 288.902 344.96V349.29H368.182V344.96C368.182 342.07 365.992 339.66 363.122 339.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.95 362.12C296.076 362.12 299.42 358.775 299.42 354.65C299.42 350.524 296.076 347.18 291.95 347.18C287.825 347.18 284.48 350.524 284.48 354.65C284.48 358.775 287.825 362.12 291.95 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.142 362.12C369.267 362.12 372.612 358.775 372.612 354.65C372.612 350.524 369.267 347.18 365.142 347.18C361.016 347.18 357.672 350.524 357.672 354.65C357.672 358.775 361.016 362.12 365.142 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93 268.69H336.28V300.62C336.28 302.9 334.43 304.75 332.15 304.75H325.06C322.78 304.75 320.93 302.9 320.93 300.62V268.69Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M320.93 268.69H336.28V300.62C336.28 302.9 334.43 304.75 332.15 304.75H325.06C322.78 304.75 320.93 302.9 320.93 300.62V268.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.899 205.4C355.899 205.4 358.079 259.4 343.039 268.69H360.199C360.199 268.69 373.499 250.29 369.739 205.4H355.889H355.899Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M355.899 205.4C355.899 205.4 358.079 259.4 343.039 268.69H360.199C360.199 268.69 373.499 250.29 369.739 205.4H355.889H355.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.051 272.83H289.131V266.14C289.131 263.38 291.371 261.14 294.131 261.14H361.051C363.811 261.14 366.051 263.38 366.051 266.14V272.83Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.93 272.83H367.24C368.35 272.83 369.25 271.93 369.25 270.82V269C369.25 267.89 368.35 266.99 367.24 266.99H287.93C286.82 266.99 285.92 267.89 285.92 269V270.82C285.92 271.93 286.82 272.83 287.93 272.83Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M287.93 272.83H367.24C368.35 272.83 369.25 271.93 369.25 270.82V269C369.25 267.89 368.35 266.99 367.24 266.99H287.93C286.82 266.99 285.92 267.89 285.92 269V270.82C285.92 271.93 286.82 272.83 287.93 272.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.959 176.45H346.459C338.407 176.45 331.879 182.978 331.879 191.03V201.79C331.879 209.842 338.407 216.37 346.459 216.37H373.959C382.011 216.37 388.539 209.842 388.539 201.79V191.03C388.539 182.978 382.011 176.45 373.959 176.45Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.052 132.33L257.562 117.86C257.562 117.86 259.912 115.68 258.302 113.47C256.692 111.26 246.562 105.04 244.712 106.14C242.862 107.23 238.772 111.35 240.982 113.64C243.202 115.93 253.012 119.74 253.012 119.74L257.862 138.73L263.042 132.33H263.052Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.382 159.84C301.382 159.84 276.412 154.71 273.702 153.48C270.992 152.25 260.942 122.82 260.942 122.82L253.242 126.42C253.242 126.42 259.442 155.96 265.782 162.99C272.122 170.01 299.172 175.96 299.172 175.96L301.382 159.85V159.84Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.172 175.94C299.172 175.94 299.012 175.91 298.712 175.83C297.342 175.52 293.082 174.52 288.012 173.03C279.782 170.64 269.402 166.98 265.782 162.97C259.452 155.94 253.242 126.4 253.242 126.4L260.942 122.8C260.942 122.8 270.992 152.24 273.712 153.46C276.422 154.68 301.382 159.81 301.382 159.81L299.172 175.92V175.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.072 122.24L262.662 125.31L252.762 128.72L253.142 124.97L261.072 122.24Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.363 175.54C297.973 175.34 293.643 174.67 288.473 173.58C291.423 168.49 300.063 165.87 300.063 165.87L299.363 175.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58 139.46C336.58 139.46 338.05 153.29 332.92 156.69C327.8 160.09 302.59 156.11 299.73 150.54C296.87 144.98 307.63 129.87 307.63 129.87L336.57 139.46H336.58Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.59 321.44L241.17 323.03L244.5 313.95L247.52 305.69L240.03 302.5L237.15 312.52L234.59 321.44Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.152 312.52L244.502 313.95L247.522 305.69L240.032 302.5L237.152 312.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.812 307.73L246.932 311.12C246.932 311.12 271.263 250.29 276.263 250.08C281.263 249.87 332.172 273.27 344.932 260.29C357.692 247.32 339.242 216.05 339.242 216.05C339.242 216.05 308.552 211.67 306.242 218.6C305.792 219.94 305.303 222.57 304.943 224.82C304.593 226.94 304.353 228.72 304.353 228.72C304.353 228.72 304.342 228.72 304.332 228.72C303.382 228.48 272.572 220.53 260.432 228.72C248.102 237.06 237.812 307.73 237.812 307.73Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M237.812 307.73L246.932 311.12C246.932 311.12 271.263 250.29 276.263 250.08C281.263 249.87 332.172 273.27 344.932 260.29C357.692 247.32 339.242 216.05 339.242 216.05C339.242 216.05 308.552 211.67 306.242 218.6C305.792 219.94 305.303 222.57 304.943 224.82C304.593 226.94 304.353 228.72 304.353 228.72C304.353 228.72 304.342 228.72 304.332 228.72C303.382 228.48 272.572 220.53 260.432 228.72C248.102 237.06 237.812 307.73 237.812 307.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.273 347.39L296.823 345.71L295.563 336.31L294.393 327.69L286.293 328.42L288.393 338.46L290.273 347.39Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.441 338.67L295.601 336.49L294.411 327.78L286.301 328.46L288.441 338.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.702 307.74L237.412 303.23L236.852 308.67L246.922 312.23L250.702 307.74Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.892 263.41C322.892 263.41 320.812 263.46 288.622 261.96C288.622 261.96 293.432 302.21 296.062 332.33L286.432 333.97C286.432 333.97 263.432 269.46 263.682 259.21C263.932 248.96 275.682 245.96 275.682 245.96C275.682 245.96 298.612 259.21 322.892 263.41Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M322.892 263.41C322.892 263.41 320.812 263.46 288.622 261.96C288.622 261.96 293.432 302.21 296.062 332.33L286.432 333.97C286.432 333.97 263.432 269.46 263.682 259.21C263.932 248.96 275.682 245.96 275.682 245.96C275.682 245.96 298.612 259.21 322.892 263.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M322.892 263.41C322.892 263.41 320.812 263.46 288.622 261.96C288.622 261.96 293.432 302.21 296.062 332.33L286.432 333.97C286.432 333.97 263.432 269.46 263.682 259.21C263.932 248.96 275.682 245.96 275.682 245.96C275.682 245.96 298.612 259.21 322.892 263.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46 329.41L284.23 330.91L286.79 336.1L297.5 334.73L297.46 329.41Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M304.352 228.72L322.302 232.46C322.302 232.46 312.382 226.98 304.942 224.82C304.592 226.94 304.352 228.72 304.352 228.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.499 211.27L339.239 216.05L306.239 218.59L305.359 212.95L338.499 211.27Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.499 211.27L339.239 216.05L306.239 218.59L305.359 212.95L338.499 211.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.091 219.274L329.723 219.106L328.869 210.8L327.237 210.967L328.091 219.274Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.439 218.439L320.664 217.974L320.312 212.496L313.087 212.96L313.439 218.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.845 220.136L309.477 219.969L308.623 211.663L306.991 211.83L307.845 220.136Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M328.091 219.274L329.723 219.106L328.869 210.8L327.237 210.967L328.091 219.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M307.845 220.136L309.477 219.969L308.623 211.663L306.991 211.83L307.845 220.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.779 159.38C300.779 159.38 309.199 162.02 319.789 161.48C330.379 160.94 343.039 166.08 343.039 166.08L338.489 211.27L305.359 212.94C305.359 212.94 294.229 175.2 300.779 159.38Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.109 133.86C306.109 133.86 307.969 111.91 326.319 119.89C349.349 129.9 331.039 156.63 319.789 151.14C308.539 145.65 306.109 133.86 306.109 133.86Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.252 162.71L311.782 175.11L315.892 169.28C315.892 169.28 314.422 183 315.282 190.46C315.282 190.46 316.072 177.07 317.932 169.28L322.302 175.11L328.572 162.79C328.572 162.79 318.422 159.14 311.242 162.71H311.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.931 165.01L326.421 162.33C320.571 158.31 323.521 149.31 323.521 149.31L314.121 152.61C314.621 154.17 314.941 155.49 315.131 156.63C316.111 162.49 313.461 162.96 313.461 162.96L316.931 165.01Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.121 152.62C314.621 154.18 314.941 155.5 315.131 156.64C319.631 154.84 323.521 149.32 323.521 149.32L314.121 152.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.262 124.5C311.942 122.66 308.272 126.52 305.762 134.96C302.632 145.51 303.322 153.65 314.232 153.66C329.052 153.68 334.082 127.55 320.262 124.49V124.5Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.241 135.69C311.241 135.69 309.611 137.61 308.051 138.61C308.051 138.61 308.511 139.9 310.041 140.04L311.241 135.7V135.69Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.493 136.13C316.323 136.81 316.553 137.45 317.013 137.56C317.463 137.67 317.973 137.21 318.133 136.53C318.303 135.85 318.073 135.21 317.613 135.1C317.163 134.99 316.653 135.45 316.493 136.13Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.793 135.18L316.453 134.24C316.453 134.24 316.883 135.67 317.793 135.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.072 133.91C307.902 134.59 308.132 135.23 308.592 135.34C309.042 135.45 309.552 134.99 309.712 134.31C309.882 133.63 309.652 132.99 309.192 132.88C308.742 132.77 308.232 133.23 308.072 133.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.371 132.96L308.031 132.02C308.031 132.02 308.461 133.45 309.371 132.96Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84 130.4C317.84 130.4 320.25 130.61 321.17 132.46",
    stroke: "#263238",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.872 128.71C311.872 128.71 310.522 127.84 308.402 128.66",
    stroke: "#263238",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.253 140.54C326.253 140.54 323.873 132.84 325.633 127.69C325.633 127.69 310.633 117.3 306.113 133.86C306.113 133.86 307.793 118.64 322.173 121.47C336.533 124.3 331.863 145.22 323.093 149.82C323.093 149.82 327.713 145.34 326.253 140.53V140.54Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.501 141.99C324.851 140.66 326.741 138.7 329.171 139.52C331.691 140.37 331.741 145.94 325.051 145.79C324.091 145.77 323.771 144.75 324.501 141.98V141.99Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.551 143.19C308.841 144.29 308.981 146.28 308.981 146.28C309.161 146.3 309.351 146.32 309.531 146.33C312.011 146.54 313.241 145.82 313.841 144.95C314.171 144.48 314.301 143.95 314.361 143.52C314.431 143.02 314.361 142.65 314.361 142.65C312.981 143.33 310.641 143.31 309.401 143.24C308.881 143.22 308.551 143.18 308.551 143.18V143.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.402 143.25L309.552 144.16C311.892 144.35 313.572 144.18 314.362 143.53C314.432 143.03 314.362 142.66 314.362 142.66C312.982 143.34 310.642 143.32 309.402 143.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.531 146.33C312.011 146.54 313.241 145.82 313.841 144.95C312.991 144.91 311.961 144.95 311.031 145.26C310.321 145.49 309.851 145.9 309.531 146.32V146.33Z",
    fill: "#DE5753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.292 125.16C320.292 125.16 320.612 139.6 329.272 141.33C337.932 143.06 328.462 122.78 328.462 122.78C328.462 122.78 315.562 114.36 306.972 120.29C298.372 126.23 306.102 133.86 306.102 133.86C306.102 133.86 307.922 123.14 320.282 125.16H320.292Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.591 124.21C320.591 124.21 317.501 133.34 323.601 138.13",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.803 144.3C330.703 147.24 327.873 148.89 325.483 147.99C323.093 147.09 322.053 143.99 323.153 141.05C324.253 138.11 327.083 136.46 329.473 137.36C331.863 138.26 332.903 141.36 331.803 144.3Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M331.803 144.3C330.703 147.24 327.873 148.89 325.483 147.99C323.093 147.09 322.053 143.99 323.153 141.05C324.253 138.11 327.083 136.46 329.473 137.36C331.863 138.26 332.903 141.36 331.803 144.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.042 139.49C329.042 139.49 332.632 123.42 324.582 119.21C324.582 119.21 326.262 119.44 327.302 119.74C328.342 120.04 334.772 126.56 331.522 141L329.042 139.49Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.042 139.49C329.042 139.49 332.632 123.42 324.582 119.21C324.582 119.21 326.262 119.44 327.302 119.74C328.342 120.04 334.772 126.56 331.522 141L329.042 139.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.952 148.69C313.752 148.66 313.552 148.63 313.352 148.6L313.512 147.61C320.762 148.79 326.152 144.96 326.202 144.92L326.792 145.73C326.562 145.89 321.322 149.66 313.952 148.69Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.952 148.69C313.752 148.66 313.552 148.63 313.352 148.6L313.512 147.61C320.762 148.79 326.152 144.96 326.202 144.92L326.792 145.73C326.562 145.89 321.322 149.66 313.952 148.69Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.46 143.9C330.73 145.84 328.86 146.93 327.28 146.34C325.7 145.75 325.01 143.69 325.74 141.75C326.47 139.81 328.34 138.72 329.92 139.31C331.5 139.9 332.19 141.96 331.46 143.9Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.062 149.01L312.262 148.9C311.662 148.82 311.242 148.28 311.322 147.68C311.402 147.08 311.942 146.66 312.542 146.74L313.342 146.85C313.942 146.93 314.362 147.47 314.282 148.07C314.202 148.67 313.662 149.09 313.062 149.01Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M313.062 149.01L312.262 148.9C311.662 148.82 311.242 148.28 311.322 147.68C311.402 147.08 311.942 146.66 312.542 146.74L313.342 146.85C313.942 146.93 314.362 147.47 314.282 148.07C314.202 148.67 313.662 149.09 313.062 149.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87 158.9L317.93 164.73L320.31 171.88L328.57 162.78L323.87 158.9Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.28 160.12L316.24 164.61L313.17 170.96L311.25 162.71L315.28 160.12Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.602 163.96L326.052 151.33C326.052 151.33 324.382 148.18 324.742 147.53C325.102 146.87 326.902 138.39 328.182 137.47C329.462 136.55 334.722 138.12 335.262 138.98C335.802 139.84 330.222 151.33 330.222 151.33L328.192 165.01L322.612 163.96H322.602Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.04 166.08C352.53 175.8 333.5 197.82 322.6 196.88C311.7 195.94 322.87 156.02 322.87 156.02L329.85 157.17C329.85 157.17 327.4 174.45 328.17 175.8C328.94 177.16 339.84 162.81 343.03 166.08H343.04Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M343.04 166.08C352.53 175.8 333.5 197.82 322.6 196.88C311.7 195.94 322.87 156.02 322.87 156.02L329.85 157.17C329.85 157.17 327.4 174.45 328.17 175.8C328.94 177.16 339.84 162.81 343.03 166.08H343.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3 154.74L321.27 158.04L331 158.9V156.02L322.3 154.74Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M307.55 180.85H303.61C303.174 180.85 302.82 181.204 302.82 181.64V189.08C302.82 189.516 303.174 189.87 303.61 189.87H307.55C307.987 189.87 308.34 189.516 308.34 189.08V181.64C308.34 181.204 307.987 180.85 307.55 180.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M307.628 181.44H303.148V187.57H307.628V181.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.99 178.67H305V182.28H305.99V178.67Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.711 334.22C224.711 333.76 225.791 333.49 226.881 333.41C226.881 333.41 230.681 331.17 234.441 322.49L238.671 322.47C240.141 322.49 241.431 323.42 241.921 324.8C241.991 324.99 242.031 325.19 242.041 325.39C242.001 326.41 241.891 327.43 241.711 328.44C241.331 331.61 239.241 338.4 239.241 338.4L238.521 338.22L239.821 331.9C240.251 329.75 238.001 331.83 236.951 333.99C235.901 336.15 234.301 338.33 229.621 337.26C224.171 335.99 221.981 335.2 223.681 334.22H223.711Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.213 320.21C235.213 320.21 229.923 331.27 226.883 333.41C226.883 333.41 230.963 335.84 235.213 330.43C240.703 323.43 242.053 325.38 242.053 325.38C242.053 325.38 241.823 322.98 241.393 321.81C240.563 319.55 235.213 320.21 235.213 320.21Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.933 360.57C282.793 359.89 283.773 359.37 284.823 359.03C284.823 359.03 287.983 355.96 289.583 346.63L293.693 345.6C295.123 345.27 296.603 345.86 297.403 347.09C297.513 347.26 297.603 347.44 297.663 347.63C297.863 348.63 298.003 349.65 298.073 350.67C298.453 353.84 298.033 360.93 298.033 360.93H297.293L297.063 354.48C296.973 352.29 295.273 354.84 294.773 357.19C294.273 359.54 293.223 362.04 288.433 362.11C282.843 362.16 280.523 361.92 281.943 360.57H281.933Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.78 344.24C289.78 344.24 287.27 356.24 284.82 359.03C284.82 359.03 289.36 360.43 292.2 354.16C295.88 346.05 297.65 347.64 297.65 347.64C297.65 347.64 296.86 345.37 296.16 344.33C294.82 342.33 289.78 344.24 289.78 344.24Z",
    fill: "#E4897B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.761 102.19H347.851C345.051 102.19 342.781 104.46 342.781 107.26V122.19C342.781 124.99 345.051 127.26 347.851 127.26H382.761C385.561 127.26 387.831 124.99 387.831 122.19V107.26C387.831 104.46 385.561 102.19 382.761 102.19Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.852 124.41L344.332 138.71L361.302 125.37L354.852 124.41Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.241 114.73C355.241 115.54 354.581 116.21 353.761 116.21C352.941 116.21 352.281 115.55 352.281 114.73C352.281 113.91 352.941 113.25 353.761 113.25C354.581 113.25 355.241 113.91 355.241 114.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.933 114.73C362.933 115.54 362.273 116.21 361.453 116.21C360.633 116.21 359.973 115.55 359.973 114.73C359.973 113.91 360.633 113.25 361.453 113.25C362.273 113.25 362.933 113.91 362.933 114.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.62 114.73C370.62 115.54 369.96 116.21 369.14 116.21C368.32 116.21 367.66 115.55 367.66 114.73C367.66 113.91 368.32 113.25 369.14 113.25C369.96 113.25 370.62 113.91 370.62 114.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.312 114.73C378.312 115.54 377.652 116.21 376.832 116.21C376.012 116.21 375.352 115.55 375.352 114.73C375.352 113.91 376.012 113.25 376.832 113.25C377.652 113.25 378.312 113.91 378.312 114.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.676 90.3802L226.77 76.9639C226.099 76.6025 225.262 76.8534 224.9 77.5244L216.952 92.2798C216.59 92.9508 216.841 93.7878 217.512 94.1492L242.419 107.566C243.09 107.927 243.927 107.676 244.288 107.005L252.236 92.2496C252.598 91.5786 252.347 90.7416 251.676 90.3802Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M251.676 90.3802L226.77 76.9639C226.099 76.6025 225.262 76.8534 224.9 77.5244L216.952 92.2798C216.59 92.9508 216.841 93.7878 217.512 94.1492L242.419 107.566C243.09 107.927 243.927 107.676 244.288 107.005L252.236 92.2496C252.598 91.5786 252.347 90.7416 251.676 90.3802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.252 78.74L232.042 93.29C232.652 94.42 233.882 95.08 235.152 94.95L251.362 93.35L234.852 95.78C233.372 96 231.922 95.22 231.292 93.86L224.242 78.74H224.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.341 76.03C205.601 70.47 209.721 59.26 214.731 55.83C219.741 52.4 216.441 57.15 216.441 57.15C216.441 57.15 221.191 52.53 223.691 52.67C226.191 52.81 223.691 55.7 223.691 55.7C223.691 55.7 228.831 52.53 231.211 52.66C233.581 52.79 231.211 55.56 231.211 55.56C231.211 55.56 235.431 52.53 237.141 53.98C238.851 55.43 215.251 70.99 212.611 77.32C209.971 83.65 205.061 81.66 205.331 76.03H205.341Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.341 76.03C205.601 70.47 209.721 59.26 214.731 55.83C219.741 52.4 216.441 57.15 216.441 57.15C216.441 57.15 221.191 52.53 223.691 52.67C226.191 52.81 223.691 55.7 223.691 55.7C223.691 55.7 228.831 52.53 231.211 52.66C233.581 52.79 231.211 55.56 231.211 55.56C231.211 55.56 235.431 52.53 237.141 53.98C238.851 55.43 215.251 70.99 212.611 77.32C209.971 83.65 205.061 81.66 205.331 76.03H205.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.622 75.21L228.772 77.23C229.002 77.38 228.882 77.73 228.612 77.71L225.302 77.45L225.582 79.99C225.612 80.27 225.272 80.42 225.082 80.21L223.172 78.05L225.612 75.21H225.622Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.622 75.21L228.772 77.23C229.002 77.38 228.882 77.73 228.612 77.71L225.302 77.45L225.582 79.99C225.612 80.27 225.272 80.42 225.082 80.21L223.172 78.05L225.612 75.21H225.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.371 62.69C181.371 62.69 185.721 59.66 192.321 61.63C192.321 61.63 194.221 70.33 199.401 73.23C202.251 74.82 209.221 74.69 214.741 72.9C221.291 70.78 224.501 70.78 225.681 73.23C226.801 75.55 225.551 78.24 220.541 79.43C215.531 80.62 211.571 89.32 202.471 89.45C193.371 89.58 188.581 80.46 190.871 72.44C190.871 72.44 188.101 66.46 181.381 62.68L181.371 62.69Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.371 62.69C181.371 62.69 185.721 59.66 192.321 61.63C192.321 61.63 194.221 70.33 199.401 73.23C202.251 74.82 209.221 74.69 214.741 72.9C221.291 70.78 224.501 70.78 225.681 73.23C226.801 75.55 225.551 78.24 220.541 79.43C215.531 80.62 211.571 89.32 202.471 89.45C193.371 89.58 188.581 80.46 190.871 72.44C190.871 72.44 188.101 66.46 181.381 62.68L181.371 62.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.181 74.8801C223.181 75.1301 222.981 75.3301 222.731 75.3301C222.481 75.3301 222.281 75.1301 222.281 74.8801C222.281 74.6301 222.481 74.4301 222.731 74.4301C222.981 74.4301 223.181 74.6301 223.181 74.8801Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.363 82.21C194.993 83.68 183.053 83.22 178.243 79.51C173.433 75.8 178.973 77.47 178.973 77.47C178.973 77.47 173.113 74.38 172.473 71.96C171.823 69.54 175.353 71.02 175.353 71.02C175.353 71.02 170.753 67.11 170.143 64.81C169.543 62.51 172.903 63.91 172.903 63.91C172.903 63.91 168.713 60.83 169.563 58.75C170.413 56.67 192.503 74.32 199.333 74.88C206.163 75.43 205.793 80.72 200.353 82.21H200.363Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M200.363 82.21C194.993 83.68 183.053 83.22 178.243 79.51C173.433 75.8 178.973 77.47 178.973 77.47C178.973 77.47 173.113 74.38 172.473 71.96C171.823 69.54 175.353 71.02 175.353 71.02C175.353 71.02 170.753 67.11 170.143 64.81C169.543 62.51 172.903 63.91 172.903 63.91C172.903 63.91 168.713 60.83 169.563 58.75C170.413 56.67 192.503 74.32 199.333 74.88C206.163 75.43 205.793 80.72 200.353 82.21H200.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.163 57.5101C164.223 57.1801 163.272 56.8601 162.312 56.5701",
    stroke: "#1976D2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.473 55.08C152.973 54.35 149.403 53.87 145.863 53.62C136.143 52.94 120.893 51.98 114.943 61.67C109.513 70.5 118.853 85.56 122.163 93.76C126.223 103.8 131.053 116.21 126.253 126.84C116.393 148.68 74.2027 137.34 59.9727 117.22",
    stroke: "#1976D2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3613 114.69C57.8613 113.81 57.4112 112.91 57.0312 112",
    stroke: "#1976D2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.808 194.09H141.848V201.87H179.808V194.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.808 194.09H141.848V201.87H179.808V194.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.838 194.09H141.848V201.87H157.838V194.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.848 195.21H175.638L141.848 196.17V195.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.81 196.56L150.52 197.29H179.81V196.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.398 198.74L157.838 198.14L179.068 198.74L157.838 199.07L143.398 198.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.848 200.39H166.868L141.848 200.98V200.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.747 200.98L163.047 201.29H179.807L179.747 200.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53 186.3H136.57V194.08H174.53V186.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.53 186.3H136.57V194.08H174.53V186.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.56 186.3H136.57V194.08H152.56V186.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.57 187.43H170.36L136.57 188.38V187.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.532 188.78L145.242 189.5H174.532V188.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.109 190.95L152.549 190.36L173.779 190.95L152.549 191.28L138.109 190.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.57 192.6H161.59L136.57 193.19V192.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.472 193.19L157.762 193.5H174.532L174.472 193.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.858 178.52H140.898V186.3H178.858V178.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.858 178.52H140.898V186.3H178.858V178.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.888 178.52H140.898V186.3H156.888V178.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.898 179.64H174.688L140.898 180.6V179.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.86 180.99L149.57 181.72H178.86V180.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M142.449 183.17L156.889 182.57L178.119 183.17L156.889 183.5L142.449 183.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.898 184.82H165.918L140.898 185.41V184.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.808 185.41L162.098 185.72H178.858L178.808 185.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.148 201.71L205.128 197.98H245.678L264.358 199.85L265.068 201.71H204.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.678 197.98V201.71H204.148L205.128 197.98H245.678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.539 180.13C237.719 182.1 236.279 183.7 234.319 183.7H172.199C170.229 183.7 168.489 182.1 168.309 180.13L164.619 140.36C164.579 139.95 164.609 139.56 164.699 139.2C165.049 137.8 166.279 136.79 167.839 136.79H229.959C231.929 136.79 233.669 138.39 233.849 140.36L237.539 180.13Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.099 183.7H172.199C170.229 183.7 168.489 182.1 168.309 180.13L164.619 140.36C164.579 139.95 164.609 139.56 164.699 139.2H226.599C228.559 139.2 230.299 140.8 230.489 142.77L234.179 182.54C234.219 182.95 234.179 183.34 234.099 183.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.417 159.3H204.267L200.847 196.1L221.167 199.15V201.71H178.367V199.15L187.137 196.1L191.417 159.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M204.271 159.3L194.751 201.13L187.141 200.9L191.421 159.3H204.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.208 362.12H198.088L187.078 208.87H195.208L204.208 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M204.218 362.12H198.088L187.618 216.48L187.078 209.12H195.208L195.648 216.48L204.218 362.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.648 216.12H187.618L187.078 209.12H195.208L195.648 216.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.171 362.12H243.051L242.051 208.87H250.171L249.171 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.181 209.12L250.021 233.84L249.181 362.12H243.051L242.211 233.84L242.051 209.12H250.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250.181 209.12L250.021 234.12H242.211L242.051 209.12H250.181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.208 362.12H308.088L297.078 208.87H305.208L314.208 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.218 362.12H308.088L297.618 216.48L297.078 209.12H305.208L305.648 216.48L314.218 362.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.648 216.12H297.618L297.078 209.12H305.208L305.648 216.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.128 362.12H128.008L137.008 208.87H145.138L134.128 362.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.138 209.12L144.598 216.48L134.128 362.12H128.008L136.568 216.48L137.008 209.12H145.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.006 209.12H145.136L144.596 216.12H136.566L137.006 209.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.57 205.03H311.65V210.54C311.65 211.73 310.68 212.7 309.49 212.7H132.73C131.54 212.7 130.57 211.73 130.57 210.54V205.03Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.57 205.03H311.65V210.54C311.65 211.73 310.68 212.7 309.49 212.7H132.73C131.54 212.7 130.57 211.73 130.57 210.54V205.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.65 205.03H130.57V208.87H311.65V205.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.449 206.04H126.769C125.579 206.04 124.609 205.07 124.609 203.88C124.609 202.69 125.579 201.72 126.769 201.72H315.449C316.639 201.72 317.609 202.69 317.609 203.88C317.609 205.07 316.639 206.04 315.449 206.04Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M315.449 206.04H126.769C125.579 206.04 124.609 205.07 124.609 203.88C124.609 202.69 125.579 201.72 126.769 201.72H315.449C316.639 201.72 317.609 202.69 317.609 203.88C317.609 205.07 316.639 206.04 315.449 206.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.811 195.05L273.131 191.57C273.591 190.88 274.371 190.46 275.211 190.46H278.151C278.401 190.46 278.641 190.5 278.871 190.57L289.361 193.75C289.961 193.93 290.461 194.33 290.781 194.86L292.281 197.39L270.801 195.05H270.811Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.289 197.39L277.019 195.73L270.809 195.05L273.129 191.57C273.589 190.88 274.369 190.46 275.209 190.46H278.149C278.399 190.46 278.639 190.5 278.879 190.57L279.109 190.64L289.359 193.75C289.959 193.93 290.469 194.32 290.789 194.86L292.289 197.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.29 197.39L277.02 195.73L279.11 190.64L289.36 193.75C289.96 193.93 290.47 194.32 290.79 194.86L292.29 197.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.549 201.38V201.71H267.129L268.329 197.02C268.799 195.26 270.399 194.03 272.219 194.03H286.599C287.079 194.03 287.549 194.11 287.999 194.28L289.799 194.95L296.939 197.61C298.509 198.2 299.549 199.7 299.549 201.38Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.548 201.38V201.71H286.238L286.948 196.64C287.138 195.3 288.528 194.48 289.798 194.95L296.938 197.61C298.508 198.2 299.548 199.7 299.548 201.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.309 198.26L292.539 185.55C292.719 185 293.349 184.75 293.869 185.01C294.259 185.21 294.459 185.66 294.349 186.09L290.779 199.66C290.779 199.66 288.409 200.62 288.309 198.26Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.81 200.66H268.93L269.29 198.81H271.17L270.81 200.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.61 200.58H271.73L272.09 198.74H273.97L273.61 200.58Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1937_6763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 372.61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsFrame);
export default __webpack_public_path__ + "static/media/contactUsFrame.830a9dee8f85b7e8481b9fe8a3e48479.svg";
export { ForwardRef as ReactComponent };